import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useCreateVideoEmbedPostMutation = createMutationHook(
  MembershipsCreatorApiClient.createVideoEmbedPost,
  {
    mutationKey: ['createVideoEmbedPost'],
  },
)
